<script>
import axios from "axios";
import moment from "moment";

export default {
  props: {
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    dispatch: {
      type: Object,
      required: false,
    },
  },
  emits: ["close-modal", 'refetch'],
  data() {
    return {
      fetchIsSuccess: undefined,
      fetchIsPending: undefined,
      fetchIsError: undefined,
    };
  },
  methods: {
    async checkAgent() {
      const { data } = await axios.get(
        `/api/admin/check-agent/${this.dispatch?.id}`
      );

      return data?.isValid;
    },
    async fetchDIN() {
      this.fetchIsPending = true;

      let valid = await this.checkAgent();

      if (!valid) {
        this.$emit("close-modal");

        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: `El administrador no ha configurado las credenciales de comext.aduanas.cl para el agente ${this.dispatch?.agente?.nombre}.`,
        });
        return;
      }
      try {
        const query = {
          responseType: "blob",
        };
        const { data } = await axios.get(
          `/api/admin/fetch-din/${this.dispatch?.id}`,
          query
        );

        this.$emit("close-modal");

        if (data) {
          const href = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = href;

          link.setAttribute(
            "download",
            "DIN" +
              "-" +
              this.dispatch?.codigo +
              "-" +
              moment(new Date()).format("DD-MM-YYYY") +
              ".pdf"
          );

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);

          this.fetchIsSuccess = true;
          this.$emit("close-modal");
          this.$emit("refetch");
        }
      } catch (err) {
        this.$emit("close-modal");

        const text = await err?.response?.data.text();
        const json = JSON.parse(text);

        if (json.errors && json.errors.length > 0) {
          this.$emit("close-modal");
          this.$swal({
            icon: "error",
            title: "¡Error!",
            text: json.errors.join("\n"),
          });
          return;
        }
      }

      this.fetchIsPending = false;
    },
  },
  watch: {
    open: async function (newValue) {
      if (newValue == true) {
        await this.fetchDIN();
      }
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      :visible="open"
      no-backdrop
      hide-header
      hide-footer
      @hidden="() => $emit('close-modal')"
      centered
    >
      <template v-slot:modal-header></template>

      <div class="flex h-48 flex-row items-center gap-4 justify-center">
        <b-spinner
          v-if="fetchIsPending"
          class="text-primary"
          style="width: 3em; height: 3em"
        />
      </div>

      <template v-slot:modal-footer>
        <div></div>
      </template>
    </b-modal>
  </div>
</template>
